import {useEffect, useState, useRef} from 'preact/hooks';
import {header} from '~/locals/wenxin/index';

const offset = 10;

const Header = (props) => {
    const {navContentRef, bannerRef} = props;
    const {logo, buttonGroupRight} = header;
    useEffect(() => {
        const header = document.querySelector('.wx-header');
        const headerWrapper = document.querySelector('.wx-header-wrapper');
        const banner = bannerRef.current.base.getBoundingClientRect();
        window.addEventListener('scroll', function () {
            var scrollTop = document.documentElement.scrollTop;
            if (scrollTop > offset) {
                header.classList.add('wx-header-fixed');
            } else {
                header.classList.remove('wx-header-fixed');
            }
            if (scrollTop >= banner.height - 100 && scrollTop < banner.height) {
                header.style = `position: absolute;
                top: ${12 - (scrollTop - banner.height + 100)}px`;
            } else if (scrollTop >= banner.height) {
                header.style = `position: absolute;
                top: -62px`;
            } else if (scrollTop === 0) {
                header.style = 'position: fixed;top: 0';
            } else {
                header.style = 'position: fixed;top: 12px';
            }

            if (scrollTop > 10) {
                headerWrapper.style = 'height: 0px';
            } else {
                headerWrapper.style = 'height: 60px';
            }
        });
    }, []);
    return (
        <div className="no_rem-wx-header wx-header-wrapper">
            <div className="wx-header">
                <div className="header-left">
                    <img src={logo} alt="logo" className="logo" />
                </div>
                <div className="header-right">
                    {buttonGroupRight.map((item) => {
                        return (
                            <a
                                key={item.id}
                                href={item.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={item.class}
                                {...item.trackInfo}
                            >
                                {item.text}
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Header;
